import type { AiSuggestionsPlugin } from './aiSuggestionsPluginType';
import { getToolbarComponents } from './ui/toolbars/toolbar-components';

export const aiSuggestionsPlugin: AiSuggestionsPlugin = ({ api }) => {
	return {
		name: 'aiSuggestions',
		pmPlugins() {
			return [
				{
					name: 'aiSuggestionsPlugin',
					plugin: ({ providerFactory }) => {
						api?.toolbar?.actions.registerComponents(getToolbarComponents(api, providerFactory));
						return undefined;
					},
				},
			];
		},
	};
};
